import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import GroupInfoEditModal from 'components/group-info/GroupInfoEditModal';
import { useRootStore } from 'store/rootStore';
import GeneralContactInfo from 'components/common/group/sidebar/GeneralContactInfo';
import ActionModal from 'components/common/modals/ActionModal';
import { ModalType } from 'global/utils/ModalsHelper';
import { createStyles } from './styles';

const ContactInfo = observer((): JSX.Element => {
  // Mobx store
  const {
    groupSidebarStore: {
      group: { name, contactInfo },
      activeEnrollmentPeriods,
    },
  } = useRootStore();

  // React local state
  const [showEditGroupModal, setShowEditGroupModal] = useState(false);
  const [showActiveEnrollmentModal, setShowActiveEnrollmentModal] = useState(false);

  // Component actions
  function onShowEditGroupModal(): void {
    setShowEditGroupModal(true);
  }

  function onCloseEditGroupModal(): void {
    setShowEditGroupModal(false);
  }

  function onShowActiveEnrollmentModal(): void {
    setShowActiveEnrollmentModal(true);
  }

  function onCloseActiveEnrollmentModal(): void {
    setShowActiveEnrollmentModal(false);
  }

  function onActiveEnrollmentModalAction(): void {
    onCloseActiveEnrollmentModal();
    onShowEditGroupModal();
  }

  function onHandleEditGroupInfo(): void {
    if (activeEnrollmentPeriods.length >= 1) {
      onShowActiveEnrollmentModal();
    } else {
      onShowEditGroupModal();
    }
  }

  const classes = createStyles();
  return (
    <>
      <header className={classes.categoryWrapper}>
        <h3 className={classes.categoryName}>Group Information</h3>
        <Button
          id="edit-group-info"
          type="text"
          iconSize="1.6rem"
          color="custom"
          customColor={colors.neutral[900]}
          leftIconProp={<Edit />}
          className={classes.editContactInfo}
          onClick={onHandleEditGroupInfo}
        >
          {' '}
        </Button>
      </header>
      <GeneralContactInfo contactInfo={contactInfo} groupName={name} />
      <GroupInfoEditModal show={showEditGroupModal} onClose={onCloseEditGroupModal} />
      <ActionModal
        show={showActiveEnrollmentModal}
        onClose={onCloseActiveEnrollmentModal}
        onAction={onActiveEnrollmentModalAction}
        title="You have an active enrollment."
        subtitle="Updating this information will not update any group information for your active enrollment."
        actionButtonText="I understand"
        modalContent={
          <p className={classes.textInfo}>
            If you would like to update group information for your active enrollment, navigate to the ‘Company Info’
            section within the enrollment checklist for your active enrollment and make updates there.
          </p>
        }
        modalType={ModalType.NOTIFICATION}
        showCloseButton={false}
      />
    </>
  );
});

export default ContactInfo;
